import { LocationDescriptor } from 'history';
import * as localStorage from 'local-storage';
import { Device, Devices, Home } from 'packages/smart-home-support/api/models';
import { DEVICES_STORAGE_KEY } from 'packages/smart-home-support/constants';
import { DeviceCode } from 'packages/smart-home-support/models';
import { DeviceQuantities } from 'packages/smart-home-support/pages/calculator/models';
import queryString from 'query-string';
import { useState } from 'react';
import { RedirectProps } from 'react-router';
import shortid from 'shortid';
import { AuthAPIError } from '../../api/authClient/errors';
import { FormController, makeFormController } from '../../components/forms';
import { PATHS } from '../../constants';
import { EnabledRedirect } from './components/RedirectWhenEnabled';
import { AuthPath, AuthSearch, MaybeUser } from './models';

type AuthFormState = { error: AuthAPIError | undefined; isLoading: boolean };
type AuthFormController = FormController & { setIsLoading: (isLoading: boolean) => void };

export const getPath = (path: AuthPath) => `/${PATHS.auth}/${path}`;

export const getTo = (path: AuthPath, search: string = ''): LocationDescriptor => ({
  pathname: getPath(path),
  search: search || window.location.search,
});

export const getLocalDevices = () => localStorage.get<DeviceQuantities | undefined>(DEVICES_STORAGE_KEY);

export const getExistingUserRedirectProps = (): RedirectProps => {
  const returnTo = queryString.parse(window.location.search)[AuthSearch.ReturnTo];
  return { to: returnTo || '/dashboard' };
};

export const getExistingUserEnabledRedirect = (user: MaybeUser): EnabledRedirect => ({
  enabled: Boolean(user),
  ...getExistingUserRedirectProps(),
});

export const useAuthForm = (submit: () => void): [AuthFormState, AuthFormController] => {
  const [error, setError] = useState<AuthFormState['error']>();
  const [isLoading, setIsLoading] = useState(false);
  const formController = makeFormController(async () => {
    setIsLoading(true);
    try {
      await submit();
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  });

  return [
    { error, isLoading },
    { ...formController, setIsLoading },
  ];
};

const oldDevicesToNew = (devices: DeviceQuantities): Devices => {
  const newDevices: Devices = [];
  Object.keys(devices).forEach((key) => {
    const count = devices[key];
    if (Number.isInteger(count)) {
      for (var i = 1; i <= count; i++) {
        const newDevice: Device = {
          id: shortid(),
          created: Date.now(),
          type: key as DeviceCode,
        };
        newDevices.push(newDevice);
      }
    }
  });
  return newDevices;
};

export const reconcileDevices = (devices: Home['devices']): Devices => {
  if (!devices) {
    const storedDevices = getLocalDevices();
    if (storedDevices) {
      localStorage.remove(DEVICES_STORAGE_KEY);
      return oldDevicesToNew(storedDevices);
    }
    return [];
  }
  if (!Array.isArray(devices)) {
    return oldDevicesToNew(devices as DeviceQuantities);
  }
  return devices as Devices;
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/auth/utils.tsx